     // ------------------- quick view
     $('.quick-view-btn').click(function(e){
        e.preventDefault();
        $('body').addClass('quick-product-show');
        var image_html = "";
        var variant_html = "";
        var select_html = "";
        var product_handle = $(this).attr('data-value');
        var product_price = $(this).attr('data-price');
        $.getJSON( '/products/' + product_handle + '.js', function( data ) {
            console.log(data);
            var title = data.title;
            // var price =  (data.price * 0.01).toFixed(2)
            var description = data.description;
            var options = data.options;
            var variants = data.variants;
            var images = data.images;

            $('.product-single__title').text(title);
            $('.product-single__price span').text(product_price);
            $('.accordion__panel').html(description);
            $('.product-single__img').attr('src', images[0]);
            $('.product-single__image').zoom({
                url: images[0],  
                });


            for(option in options){
                var option_name = options[option].name;
                var option_position = options[option].position;
                var option_values = options[option].values;
                variant_html += '<div class="variant__option">';
                variant_html += ' <div class="variant__option-name">';
                variant_html += option_name;
                variant_html += '</div>';
                variant_html += '<div class="variant__items">';
          

            for(value in option_values){
                variant_id = option_values[value].toLowerCase().replace(/ /g,'-');
                variant_html += '<div class="variant__item">';
                if(value == 0){
                    variant_html += '<input type="radio" value="'+option_values[value]+'" name="option'+option_position+'" id="'+variant_id+value+'" checked class="variant__input variant__input_new variant-checked">';
                }else{
                    variant_html += '<input type="radio" value="'+option_values[value]+'" name="option'+option_position+'" id="'+variant_id+value+'" class="variant__input variant__input_new">';
                }
                
                variant_html += '<label for="'+variant_id+value+'" class="variant__label ">'+option_values[value]+'</label>';
                variant_html += '</div>';
            }
              
              
              
          
                variant_html += '</div>';
                variant_html += '</div>';

            }
            $('.variant').html(variant_html);
            $('.variant__items .variant__item:first-child input').prop("checked", true);


            var availability = '';
            for(variant in variants){
                if(variants[variant].available == true){
                    availability = 'available'
                }
                else{
                    availability = 'unavailable'
                };
                if(variant == 0){
                    select_html += '<option availablity="'+availability+'" value="'+variants[variant].id+'" option0="'+variants[variant].options[0]+'" option1="'+variants[variant].options[1]+'" option2="'+variants[variant].options[2]+'" variant-image="'+variants[variant].featured_image.src+'" selected="selected">';
                }else{
                    select_html += '<option availablity="'+availability+'" value="'+variants[variant].id+'" option0="'+variants[variant].options[0]+'" option1="'+variants[variant].options[1]+'" option2="'+variants[variant].options[2]+'" variant-image="'+variants[variant].featured_image.src+'">';
                }
                
                select_html += variants[variant].title;
                select_html += '</option>';
            }

            $('.my-variant').html(select_html);
            // $('.variant__items').each(function(){
            //     $(this).find('.variant__item:first-child input').prop("checked", true);
            // })
            // $('.variant__items .variant__item:first-child input').prop("checked", true);
            // $('.variant__items .variant__item:first-child input').attr('checked', 'checked');






            for(image in images){
                image_html += '<div class="product-single__thumb">';
                image_html += '<a class="product-single__thumb-src" href="'+images[image]+'" data-product-single-thumbnail>';
                image_html += '<img src="'+images[image]+'"  alt="product-description-thumb">';
                image_html += '</a>';
                image_html += '</div>';
            };
            $('.product-single__thumbs_1').attr('id', 'thumb-wrap-'+data.id);
            $('.product-single__thumbs_1').html(image_html);
            var $slider = $('#thumb-wrap-'+data.id);
            // $slider.slick('unslick');

            
            $slider.slick({
                dots: false,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 3,
                centerMode: false,
                vertical: false,
                prevArrow: "<div class='hero__slider-arrow hero__slider-arrow_left'><i class='icon-chevron-left'></i></div>",
                nextArrow: "<div class='hero__slider-arrow hero__slider-arrow_right'><i class='icon-chevron-right'></i></div>"
                // fade: true
                // adaptiveHeight: true
            });
          });

          

    });


    $('.shop-quick-close').click(function () {
        $('.product-single__thumbs_1').slick('unslick');
        $('.product-single__thumb').remove();
        $('body').removeClass('quick-product-show')

    })






    // ------------------ Variant selection on change ----------------------\\
var my_pick = {};

$(document).on('change', '.variant__input_new', function(){
    var variant = "";
    $(this).parent().parent().find('.variant__input').removeClass('variant-checked');
    $(this).addClass('variant-checked');
    $('.variant__input:checked').each(function (index) {
      my_pick[index] = $(this).attr('value');
      variant += '[option' + index + '="' + my_pick[index] + '"]';
    });
    $('.my-variant option').attr("selected", false);
    $(variant).attr("selected", true);
  
    var selected_variant = $(variant).attr('value');
    var availablity = $(variant).attr('availablity');
  
    if (availablity == 'available') {
      $('.viable-button__add-to-cart').addClass('active');
      $('.viable-button__add-to-cart_disabled').removeClass('active');
      $('.variant_selected').attr('value', selected_variant);
    } else {
      $('.viable-button__add-to-cart').removeClass('active');
      $('.viable-button__add-to-cart_disabled').addClass('active');
    }


    // var product_wrapper_height = $('.product-single__img').height();
    // $('.product-single__image').css('height', product_wrapper_height);


    var new_image_src = $('.my-variant option:selected').attr('variant-image');
    var new_image = "<img class='product-single__img' src='"+new_image_src+"'/>"
    $('.product-single__img').replaceWith(new_image);
    $('.zoomImg').attr('src', new_image_src)
    $('.product-single__image').trigger('zoom.destroy');
    $('.product-single__image').zoom({
      url: new_image_src,  
      });
    console.log(variant);
    
})





  // ------------------ Product image change on click ----------------------\\


  $(document).on('click', '.product-single__thumb-src', function(e){
    e.preventDefault();
    $('.product-single__thumb').removeClass('active');
    $(this).parent().addClass('active');

    // var product_wrapper_height = $('.product-single__image').height();
    // $('.product-single__image').css('height', product_wrapper_height);

    var new_image_src = $(this).attr('href');
    var new_image = "<img class='product-single__img' src='"+new_image_src+"'/>"
    $('.product-single__img').replaceWith(new_image);
    $('.zoomImg').attr('src', new_image_src)
    $('.product-single__image').trigger('zoom.destroy');
    $('.product-single__image').zoom({
      url: new_image_src,    
      });
})